export default {"src":"/_next/static/media/DownArrow.ec8336cb.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};